import React from "react";
import { notification } from "antd";
import { EmbedEvent, Action, Page } from "@thoughtspot/visual-embed-sdk";
import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';

export const actionSet = [
  Action.Subscription,
  Action.Share,
  Action.Save,
  Action.Edit,
  Action.EditTitle,
  Action.Explore,
  Action.Pin,
  Action.SpotIQAnalyze,
  Action.DrillDown
];

export function useEventLogger() {
  const t0 = React.useRef(Date.now());

  return function logEvent(nameOrE: any) {
    if (typeof nameOrE === "string") {
      return (e: any) => {
        e.type = nameOrE;
        logEvent(e);
      };
    }
    if (nameOrE.type === EmbedEvent.Init) {
      t0.current = nameOrE?.data.timestamp;
    }
    const evtDetails = `${nameOrE.type || nameOrE.__type} ${nameOrE.id || ""}`;
    notification.info({
      message: `Event ${evtDetails}`,
      placement: "bottomRight",
      duration: 2
    });
    console.log(
      `[Event] ${evtDetails}`,
      `delta: ${(Date.now() - t0.current) / 1000}`,
      getPrettyEventPayload(nameOrE.data)
    );
  };
}

function getPrettyEventPayload(payload: any) {
  if (typeof payload === "string") {
    return JSON.parse(payload);
  }
  return payload;
}


export const GetConfig = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const configBase64 = params.get('config');
  const config = configBase64 ? JSON.parse(atob(configBase64)) : null;
  return config;
};

export const GetLanguageTS: any = (lang: string) => {
  let language = 'es-ES'
  switch (lang) {
    case 'en':
      language = 'en-US'
      break;
    case 'pt':
      language = 'pt-BR'
      break;
    default:
      break;
  }
  return language;
};

export const GetLanguage: any = (lang: string) => {
  let language = 'es_ES'
  switch (lang) {
    case 'en':
      language = 'en_US'
      break;
    case 'pt':
      language = 'pt_BR'
      break;
    default:
      break;
  }
  return language;
};

export const GetPageByPage = (path: string) => {
  switch (path) {
    case 'home':
      return Page.Home;
      break;
    case 'search':
      return Page.Search;
      break;
    case 'answers':
      return Page.Answers;
      break;
    case 'liveboards':
      return Page.Liveboards;
      break;
    case 'pinboards':
      return Page.Pinboards;
      break;
    case 'spotiq':
      return Page.SpotIQ;
      break;
    default:
      return Page.Home;
      break;
  }
}

export const Capitalize = (s: string) => s.replace(/./, c => c.toUpperCase())

export const rangePresets: {
  label: string;
  value: [Dayjs, Dayjs];
}[] = [
    { label: 'global.title.today', value: [dayjs().startOf('day'), dayjs()] },
    { label: 'global.title.yesterday', value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')] },
    { label: 'global.title.this.week', value: [dayjs().startOf('week'), dayjs()] },
    { label: 'global.title.last.week', value: [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')] },
    { label: 'global.title.last.30.days', value: [dayjs().add(-30, 'd').startOf('day'), dayjs()] },
    { label: 'global.title.this.month', value: [dayjs().startOf('month'), dayjs()] },
    { label: 'global.title.last.month', value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] },
    { label: 'global.title.this.quarter', value: [dayjs().startOf('quarter'), dayjs()] },
    /* { label: 'global.title.last.quarter', value: [dayjs().subtract(1, 'quarter').startOf('quarter'), dayjs().subtract(1, 'quarter').endOf('quarter')] },
    { label: 'global.title.this.year', value: [dayjs().startOf('year'), dayjs()] }, */
  ];

interface MyObject {
  [key: string]: any;
}

export function removeKeyFromObject(obj: MyObject, key: string): MyObject {
  const { [key]: deletedKey, ...rest } = obj;
  return rest;
}

export function getCookie(name: string): string | null {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}


export const analyticsItems: any = {
  "integrations": ['4c7ab200-daa9-4f15-a6cf-dc90bc6245c9', '06331699-b28a-4fb5-8f4f-b088b2bafab0', 'ad9c49dc-40b3-4c0c-a5c6-f1fd30344f75'],
}
